export default [
    {
        path: '/no-autorizado',
        name: 'misc-not-authorized',
        component: () => import('@/views/miscellaneous/NotAuthorized.vue'),
        meta: {
            layout: 'full',
            resource: 'ACL'
        }
    }
]